import { Component } from '@nicolas-riciotti/light2';
import Tween from '../../helpers/Tween.js';


export default class BlockNews extends Component {

  created() {
    this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
  }

  siteSettingsMotionChange(event) {
    this.stopped = ('off' === event.detail);
  }

  detached() {
    document.removeEventListener('site_settings_motion', this.siteSettingsMotionChange);
  }

  attached() {

    document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);

    this.$inputs = this.querySelectorAll('input');

    this.$inputs?.forEach(el => {
      el.addEventListener('change', async e => {
        const input = e.target;
        const name = input.name;
        const value = input.value;
        const url = new URL(window.location);
        const params = url.searchParams;
        const isArray = name.endsWith('[]');
        if (isArray) {
          params.delete(name);
          const allSame = [...this.$inputs].filter(i => i.name === name && i.value);
          allSame.forEach(i => params.append(name, i.value));
        } else {
          if (value) params.set(name, value);
          else params.delete(name);
        }
        const newUrl = `${url.pathname}?${params.toString()}`;
        history.pushState({}, '', newUrl);
        // Update container
        await this.updateNewsContainer(newUrl);
      });
    });
  }

  async updateNewsContainer(url) {
    const currentContainer = this.querySelector('#news-container');
    if (!currentContainer) return;
    // Destroy any running tween
    this.tween?.destroy();
    // Create a Promise that resolves when fade-out completes
    const fadeOut = new Promise(resolve => {
      this.tween = Tween({ e: 0 }, {
        to: { e: 1 },
        easing: [0.43, 0.195, 0.02, 1],
        duration: this.stopped ? 0.01 : 700,
        step: e => {
          currentContainer.style.opacity = 1 - e;
        },
        end: () => resolve()
      });
    });
    // Create a Promise that performs the fetch
    const fetchContent = (async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContainer = doc.querySelector('#news-container');
        return newContainer ? newContainer.innerHTML : null;
      } catch (err) {
        console.error('❌ Failed to update news:', err);
        return null;
      }
    })();
    // Wait until both fade-out and fetch have finished
    const [ , newHTML ] = await Promise.allSettled([fadeOut, fetchContent])
      .then(results => [results[0].status, results[1].value]);
    // If fetch succeeded, update content
    if (newHTML) currentContainer.innerHTML = newHTML;
    // Fade-in animation (always runs after both)
    this.tween?.destroy();
    this.tween = Tween({ e: 0 }, {
      to: { e: 1 },
      easing: [0.43, 0.195, 0.02, 1],
      duration: this.stopped ? 0.01 : 700,
      step: e => {
        currentContainer.style.opacity = e;
      },
    });
  }

}

customElements.define('block-news', BlockNews);
